module.exports = __webpack_public_path__ + "media/icons/Info-bb1c9177.svg";